import { MarkdownStyle } from "../components/markdown/Markdown";
import Container from "../components/Container";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

export default function About() {
    return (
        <>
            <Helmet>
                <title>ReinVB — About</title>
                <meta name="description" content="Let's learn more about the life of Rein Vanbelleghem." />
            </Helmet>
            <Container className="mt-4 lg:mt-8 xl:mt-16">
                <MarkdownStyle className="max-w-full">
                    <h1>About me.</h1>
                    <motion.hr animate={{ width: "100%" }} transition={{ duration: 2 }} className={`-mt-6 w-0 max-w-[10rem] rounded border-t-4 border-orange-400 dark:border-orange-400`} />

                    <img src="/images/me.jpeg" alt="Rein Vanbelleghem" className="float-right mb-2 ml-2 mt-0 hidden h-48 w-48 !rounded-full object-cover md:block lg:h-56 lg:w-56" />
                    <p>Hello, I'm Rein Vanbelleghem, a student pursuing a degree in Industrial Engineering Informatics at the University of Ghent. Currently in my third year of studies, I am passionate about creating dynamic and visually appealing websites using the latest programming languages.</p>

                    <p>
                        During my time as a student, I have had the privilege of being the ICT representative for a student group called Hermes. As part of this role, I developed their website and also designed a dedicated website for the recruitment segment of the group. These experiences have
                        allowed me to gain hands-on expertise and a deep understanding of web development.
                    </p>

                    <p>My approach to work is characterized by hard work and attention to detail, particularly when it comes to design. I strive to create websites that not only function flawlessly but also captivate users with their aesthetic appeal.</p>

                    <p>In addition to my academic pursuits, I am actively involved in the education committee of Industrial Engineering Informatics at UGent. Here, I engage in discussions related to solving problems and implementing changes within our study program.</p>
                    <p>When I'm not immersed in the world of programming and web development, I enjoy exploring other interests and hobbies. These diverse experiences contribute to my creativity and ability to think outside the box.</p>
                    <p>I am excited to continue honing my skills, exploring new technologies, and creating innovative solutions in the field of web development. Join me on this journey as we navigate the digital landscape and bring ideas to life.</p>
                </MarkdownStyle>
            </Container>
        </>
    );
}
